import React from 'react';
import cx from 'classnames';
import NavLink from '../../components/NavLink';

export default ({label, link, className, style, onClick, pointerStyles, labelStyles, ...props}) => {
    return (
        <NavLink
            className = { cx('hud-map__location', className) }
            style = { style }
            to = { link }
            onClick = { onClick }
        >
            <div
                className = 'hud-map__location__pointer'
                style = { typeof pointerStyles !== 'undefined' ? pointerStyles : {} }
            />

            { label && (
                <div
                    className = 'hud-map__location__label'
                    style = { typeof labelStyles !== 'undefined' ? labelStyles : {} }>
                    {label}
                </div>
            )}
        </NavLink>
    );
};
